import React, { useState, useEffect, useRef } from 'react';
import { Form } from 'antd';
import FormCard from 'pages/NewUniProfile/components/FormCard';
import TimezoneOperationhours from 'components/Calendar/TimezoneOperationhours';
import s from './s.module.less';
import { IproviderAvailabilityList } from 'types/appointmentSetting';
import { SUPPORT_TIME_ZONE } from 'constants/common';
import { transferTimePicker } from 'components/Calendar/DatesOverride/utils';
import commonS from '../../s.module.less';

interface Props {
    initValue?: IproviderAvailabilityList | null;
    onSave?: () => void;
}

const WorkingHours: React.FC<Props> = (props) => {
    const { initValue, onSave } = props;
    const timeRef = useRef<{ onUpdate:() => Promise<void> }>(null);

    const handleSave = async () => {
        try {
            await timeRef.current?.onUpdate();
            onSave?.();
        } catch (error) {
            console.error('Form save failed:', error);
        }
    };

    const renderEditing = () => {
        return (
            <div className={s.editingContainer}>
                <TimezoneOperationhours ref={timeRef} autoSave={false} />
            </div>
        );
    };

    const renderReview = () => {
        if (!initValue || !initValue.week?.length) {
            return (
                <div>
                    Not provided
                </div>
            );
        }

        const { timezone, week } = initValue;
        const weekData = week?.filter((item) => item.hourFromTo?.length);

        const weekOrder = {
            sunday: 0,
            monday: 1,
            tuesday: 2,
            wednesday: 3,
            thursday: 4,
            friday: 5,
            saturday: 6,
        };

        // 按照星期顺序排序
        const sortedWeekData = weekData?.sort((a, b) => {
            const orderA = weekOrder[a.weekDay?.toLowerCase() as keyof typeof weekOrder] ?? 7;
            const orderB = weekOrder[b.weekDay?.toLowerCase() as keyof typeof weekOrder] ?? 7;
            return orderA - orderB;
        });

        return (
            <div className={commonS.displayItem}>
                <div className={commonS.label}>Timezone</div>
                <div className={commonS.value}>{SUPPORT_TIME_ZONE.find((item) => item.dictKey === timezone)?.label}</div>
                <div className={s.workingHoursList}>
                    {sortedWeekData.map((hour, index) => (
                        <div key={index} className={s.workingHourItem}>
                            <span className={commonS.value}>{hour.weekDay!.charAt(0).toUpperCase() + hour.weekDay!.slice(1)}</span>
                            <span className={commonS.value}>
                                {hour.hourFromTo?.map((item, i) => <div key={i}>{transferTimePicker(item)}</div>)}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <FormCard type="review" title="Working hours" hasContent onSave={handleSave}>
            {(isEditing) => (isEditing ? renderEditing() : renderReview())}
        </FormCard>
    );
};

export default WorkingHours;
